/* eslint-disable react/no-danger */
import { isEmpty, map } from 'lodash';
import React from 'react';
import { motion } from 'framer-motion';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Link } from 'gatsby';

export default function FreeZoneTextContentWithOneColumnLists({ data, id }) {
  const { title, text, items } = data;
  return (
    <section id={id} className="pt-[50px] md:pt-[100px] pb-[60px] md:pb-[120px]">
      <div
        className="max-w-[890px] mx-auto relative px-6 xl:px-0 flex flex-col
      gap-y-6 md:gap-y-[44px]">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.4 }}
          viewport={{ once: true }}
          className="flex flex-col gap-y-6 md:gap-y-8">
          <div className="flex flex-col gap-y-5">
            <div
              dangerouslySetInnerHTML={{ __html: title }}
              className="text-clamp20to40  h2-child:text-clamp20to40 text-[#231F20]
            h2-child:leading-1.2  text-center h2-child:!m-0"
            />
            <div className="h-[2px] w-[50px] md:w-[70px] bg-[#CE445B] mx-auto" />
          </div>
          <div
            dangerouslySetInnerHTML={{ __html: text }}
            className="p-child:text-[#4A4A4A] p-child:text-clamp12to18 p-child:font-normal
            p-child:leading-[1.6] p-child:mb-0 p-child:ltr:font-URWDINRegular p-child:rtl:font-GESSTwoDWTCLight text-center"
          />
        </motion.div>
        {isEmpty(items) || (
          <div
            className="border border-[#E6E6E6] bg-[#F7F7F7] px-5 py-6 md:p-[30px] lg:p-[60px]
          flex flex-col gap-y-9">
            {map(items, (item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.2 * (index + 1), delay: 0.6 }}
                className="flex flex-row gap-x-[10px] items-start">
                <div className="min-w-[30px] min-h-[30px]">
                  {isEmpty(item.content.oneColumnListIcon) || (
                    <LazyLoadImage
                      src={item.content.oneColumnListIcon.url}
                      width="100%"
                      effect="blur"
                      wrapperClassName="relative ltr:top-[-4px] rtl:top-[-1px]"
                      className="w-full h-full object-cover"
                    />
                  )}
                </div>
                <div
                  className="text-clamp12to18 text-[#4D4D4D] 
                ltr:font-URWDINMedium rtl:font-GESSTwoDWTCMedium leading-1.5 !m-0
                [&>p]:text-[#4D4D4D] [&>ol]:mb-4 [&>ol]:pl-5 [&>ol]:list-alpha 
                [&>*>*>ul]:list-lower-roman [&>*>*>ul]:pl-5
                ">
                  <div
                    dangerouslySetInnerHTML={{ __html: item.content.oneColumnListTitle }}
                    className={`text-[#4D4D4D] [&>p]:text-[#4D4D4D] [&>p]:m-0
                    [&>*>*>a]:underline hover:[&>*>*>a]:no-underline flex flex-col gap-2
                    ${item.content.link ? 'inline-block' : ''}`}
                  />
                  {item.content.link ? (
                    <>
                      {' '}
                      <a className="text-[#4D4D4D] hover:underline" href={item.content.link.url}>
                        {item.content.link.name}
                      </a>
                    </>
                  ) : (
                    ''
                  )}
                </div>
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
